import { render, staticRenderFns } from "./CheckpointsTable.vue?vue&type=template&id=6f3f0aa7"
import script from "./CheckpointsTable.vue?vue&type=script&lang=js"
export * from "./CheckpointsTable.vue?vue&type=script&lang=js"
import style0 from "./CheckpointsTable.vue?vue&type=style&index=0&id=6f3f0aa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports